<template>
  <div>
    <div class="d-flex gap-8">
      <div>
        <span class="text-dark bold">Ranked business:</span>
        <p>
          <span v-if="!attrs.locationPath">{{ attrs.businessName }}</span>
          <a v-else :href="attrs.locationPath" target="_blank">
            {{ attrs.businessName }}
            <i class="far fa-external-link small" />
          </a>
          <a v-if="attrs.businessLocationLat" href="#" @click.prevent="toggleBusinessMarker(attrs)">
            <i class="far fa-map-marker" aria-hidden="true" />
          </a>
          <small v-if="attrs.businessPlaceId" class="d-block font-italic">({{ attrs.businessPlaceId }})</small>
        </p>
      </div>
      <div>
        <span class="text-dark bold">Search term:</span>
        <p>{{ geogrid.searchTerm }}</p>
      </div>
      <div v-if="attrs.mapUrl">
        <span class="d-block text-dark bold">Google map URL:</span>
        <a :href="attrs.mapUrl" class="text-truncate" target="_blank">https://www.google.com/maps/...</a>
      </div>
      <div class="geogrid-live-show">
        <span v-if="openNote || note.length" class="text-dark bold">Note:</span>
        <div class="form-field">
          <quick-edit
            empty-text="Note:"
            type="textarea"
            :classes="vueQuickEditClasses"
            :show-buttons="false"
            @show="showTextareaNote"
            @close="updateNote"
            v-model="note" />
        </div>
      </div>
    </div>
    <tags ref="tags"
      :show-edit-buttons="true"
      :add-tag-path="geogrid.addTagPath"
      :remove-tag-path="geogrid.removeTagPath"
      @updateRowWithNewTags="updateRowWithNewTags" />
  </div>
</template>

<script>
import QuickEdit from 'vue-quick-edit'
import toastr from 'toastr'
import { mapMutations, mapState } from 'vuex'
import tags from '../components/tags'
import { DEFAULT_ERROR_MESSAGE } from '../../../common/constants'

export default {
  name: 'GeogridDetails',
  components: { tags, QuickEdit },
  props: {
    apiGeogridsPath: String
  },
  data() {
    return {
      openNote: false,
      note: ''
    }
  },
  computed: {
    ...mapState(['geogrid']),
    attrs() { return this.geogrid.attrs }
  },
  watch: {
    geogrid() {
      this.$refs.tags.renderTags(this.geogrid.tags || [])
      this.note = this.geogrid.note || ''
    }
  },
  created() {
    this.vueQuickEditClasses = { input: 'textareaClass scroll', link: 'text-break' }
  },
  methods: {
    ...mapMutations(['toggleBusinessMarker']),
    updateRowWithNewTags(newTags) {
      this.geogrid.tags = newTags
      this.$emit('reloadHistory')
    },
    updateNote(text) {
      this.note = text.trim()
      this.openNote = false
      axios.put(`${this.apiGeogridsPath}/${this.geogrid.obfuscatedId}`, { note: this.note }).catch((_error) => {
        toastr.error(DEFAULT_ERROR_MESSAGE)
      })
    },
    resizeNote() {
      this.textarea.style.height = '0px'
      this.$nextTick(() => {
        this.textarea.style.height = `${this.textarea.scrollHeight}px`
      })
    },
    showTextareaNote() {
      this.openNote = true
      this.$nextTick(() => {
        [this.textarea] = $('.textareaClass')
        this.resizeNote()
        this.textarea.addEventListener('input', this.resizeNote)
      })
    }
  }
}
</script>
